<template>
  <div>
    <apexchart width="500" type="bar" :options="options" :series="series"></apexchart>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  components: {
    apexchart: VueApexCharts
  },

  data() {
    return {
      options: {
        /*
        chart: {
          id: 'vuechart-example'
        },
        */
        plotOptions: {
            bar: {
                //horizontal: true,
                barHeight: '100%',
                    distributed: true,
                    horizontal: true,
                    dataLabels: {
                        position: 'bottom'
                    },
            }

        },
        xaxis: {
          categories: ['Rischio 1', 'Rischio 2', 'Rischio 3', 'Rischio 4']
        },
        colors: ['#33b2df', '#546E7A', '#d4526e', '#13d8aa'],
      },
      series: [{
        data: [50, 40, 30, 20]
      }]
    }
  }
};
</script>
